export default __webpack_public_path__ + "static/faq-tablet-bottom-254d59bb20e191dcc132eb0da29fd717.jpg";